import {
	GetReferredPlayersRequest,
	GetReferredPlayersResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@/core/api/type'
import { useQuery } from '@tanstack/react-query'
import { getReferredPlayers } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerReferred(
	playerId: string,
	payload: GetReferredPlayersRequest,
	props?: UseBaseQueryOptions<GetReferredPlayersResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetReferredPlayers, playerId, payload],
		queryFn: () => getReferredPlayers(playerId, payload),
		...props,
	})
}
